import { roundTo } from "./mathUtils";

export const formatDate = (fecha) => {
  const date = new Date(fecha);
  if (isNaN(date.getTime()) || fecha == null) {
    return ""; // Manejo de fechas inválidas
  }
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour12: true,
    timeZone: "UTC",
  };
  return date.toLocaleString("es-GT", options).replace(",", "");
};

export const formatQTZ = (monto, decimales = 2) => {
  if (monto === null || monto === undefined || isNaN(monto)) {
    return ""; // Manejo de montos inválidos
  }

  const options = {
    style: "currency",
    currency: "GTQ",
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  };

  return new Intl.NumberFormat("es-GT", options).format(monto);
};

export const formatNum = (monto, decimales = 2) => {
  if (monto === null || monto === undefined || isNaN(monto)) {
    return "0.00"; // Manejo de montos inválidos
  }

  const options = {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  };

  return new Intl.NumberFormat("es-GT", options).format(monto);
};

export const formatNumber = (num) => {
  if (num >= 1000000) {
    return roundTo(num / 1000000) + " G";
  } else if (num >= 1000) {
    return roundTo(num / 1000) + " M";
  }
  return num?.toLocaleString();
};

export const formatNumberQTZ = (num) => {
  if (num >= 1000000) {
    return formatQTZ(num / 1000000) + "M";
  } else if (num >= 1000) {
    return formatQTZ(num / 1000) + "K";
  }
  return num?.toLocaleString();
};

export const formatNumMil = (num, decimales = 2) => {
  if (num === null || num === undefined || isNaN(num)) {
    return "0.00"; // Manejo de montos inválidos
  }

  if (num >= 1000000) {
    return formatNum(num / 1000000, decimales) + " M";
  } else if (num >= 1000) {
    return formatNum(num / 1000, decimales) + " k";
  }
};

export const formatNumKgT = (num, decimales = 2) => {
  if (num < 10) {
    return roundTo(num * 1000, decimales) + " kg";
  } else if (num >= 10) {
    return roundTo(num, decimales) + " (T)";
  }
  return num?.toLocaleString();
};

export const formatNumMilSplit = (num, decimales = 2) => {
  if (num === null || num === undefined || isNaN(num)) {
    return "0.00"; // Manejo de montos inválidos
  }

  if (num >= 1000000) {
    return {
      numero: formatNum(num / 1000000, decimales),
      letra: "M"
    }
  } else if (num >= 1000) {
    return {
      numero: formatNum(num / 1000, decimales),
      letra: "k"
    }
  }
};